import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

import { httpService } from '@/api/v1/http.service'
import { requiredString } from '@/utils/zod'

const responseSchema = z.array(
  z.object({
    id: requiredString(),
    name: requiredString(),
    course: z.object({
      id: requiredString(),
      display_name: requiredString()
    })
  })
)

export type Group = {
  id: string
  name: string
  course: {
    id: string
    displayName: string
  }
}

const parseResponse = (response: z.infer<typeof responseSchema>): Group[] =>
  response.map(item => ({
    id: item.id,
    name: item.name,
    course: {
      id: item.course.id,
      displayName: item.course.display_name
    }
  }))

const useGroups = (params: {
  classIds?: string[]
  studentIds?: string[]
  teacherOrCoTeacherId?: string[]
  semester?: string
}) =>
  useQuery({
    queryKey: ['panelLessonsGroupsList', params],
    staleTime: 60 * 100,
    queryFn: async () => {
      const response = await httpService.panel.panelLessonsGroupsList({
        // @ts-expect-error Waits for backend fix
        page_size: 'max',
        class_id: params.classIds,
        student_id: params.studentIds,
        teacher_or_co_teacher_id: params.teacherOrCoTeacherId,
        semester_id: params.semester,
        fetchKeys: {
          id: true,
          name: true,
          course: true
        }
      })
      const parsed = parseResponse(responseSchema.parse(response.results))

      return {
        options: parsed.map(group => ({
          label: group.name,
          value: group.id
        })),
        list: parsed
      }
    }
  })

export default useGroups
